import CreateWindow from "../puzzleWindow";
import pieceImages from "pieces/*.png";
import { html, render } from "lit-html";
import "./index.css";
import { tips } from "~/src/tips";
import inside from "point-in-polygon";
import polygons from "./polygons.js";
import posterBg from "./poster-bg.jpg";
import { mobileOrNot } from "../../helpers/mobileDetect";
import { scaleLinear } from "d3-scale";
import { getWidth, getHeight, getOffset } from "./helpers.js";
import { getArrayRandomElement } from "~/src/helpers/getArrayRandomElement.js";
import { userChoiceTracker } from "~/src/helpers/userChoiceTracker.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition";
let scale;
let puzzleOpened = false;
let currentData;
let posterPuzzleSounds;
let correctPieces = [];
export const updateMatrixPosterScale = () => {
  // do nothing if poster puzzle already solved
  if (!document.getElementById("poster") || userChoiceTracker.retrieve().posterPuzzle) return;
  scale = scaleLinear()
    .domain([0, document.getElementById("poster").clientWidth])
    .range([0, 800]);
};
const containerSelector = () => document.getElementById("poster");

const findSiblingsUnderMouse = function (evt) {
  const el = evt.target;
  const children = Array.from(el.parentNode.children).reverse();

  let arr = [];
  for (let index = 0; index < children.length; index++) {
    var t = children[index];
    // check if clicked point (taken from event) is inside element
    var x = (evt.pageX - getOffset(t).left).toFixed();
    var y = (evt.pageY - getOffset(t).top).toFixed();
    var w = getWidth(t);
    var h = getHeight(t);
    if (x < 0 || x >= w || y < 0 || y >= h) return;
    arr.push(t);
  }
  return arr;
};

const isOnVisiblePixel = function (e, element) {
  if (e.type == "mouseleave") return false;

  const touchX = e.pageX ? e.pageX : e.touches[0].pageX;
  const touchY = e.pageY ? e.pageY : e.touches[0].pageY;

  var t = element;
  if (!t || t.tagName != "IMG") t = this.find("img")[0];
  if (!t) return;

  var w = getWidth(t);
  var h = getHeight(t);
  var o = getOffset(t);
  var x = (touchX - o.left).toFixed();
  var y = (touchY - o.top).toFixed();
  if (x < 0 || y < 0 || x >= w || y >= h) return false;

  let ctx = document.createElement("canvas").getContext("2d");
  ctx.canvas.width = w;
  ctx.canvas.height = h;
  ctx.drawImage(t, 0, 0, w, h);
  const alpha = ctx.getImageData(x, y, 1, 1).data[3];
  ctx = null;
  return alpha > 249;
};
let mousedown = false;
let image = null;
let initialX, initialY;
let diffX, diffY;

function stop(evt) {
  mousedown = false;
  if (!image) return;
  image.style.zIndex = "unset";
  const evv = evt.touches ? evt.changedTouches[0] : evt;

  var rect = document.getElementById("poster").getBoundingClientRect();
  var x = evv.clientX - rect.left; //x position within the element.
  var y = evv.clientY - rect.top; //y position within the element.

  const data = polygons.find((e) => e.name === image.id).data;
  const parsedData = data.map((e) => [e.x, e.y]);
  //  console.log([ scale(evt.layerX), scale(evt.layerY) ])

  document.removeEventListener("mousemove", move);
  document.removeEventListener("touchmove", move);
  const rightPlace = inside([scale(x), scale(y)], parsedData);
  if (rightPlace) {
    posterPuzzleSounds?.paperRightPlace?.play();
    const stackIndex = polygons.find((e) => e.name === image.id).stackIndex;
    correctPieces.push(image.id);
    if (!mobileOrNot()) image.classList.add("animated");
    image.style.left = 0;
    image.style.top = 0;
    image.style.zIndex = stackIndex;
    if (correctPieces.length === 10) {
      userChoiceTracker.processAnswer("posterPuzzle", true);
    }
  } else {
    const id = image.id;
    const container = containerSelector();
    const polygonData = polygons.find((e) => e.name === id);
    window.scene.getSoundByName("matrixPosterPaperMovement")?.play();

    if (!mobileOrNot()) {
      image.classList.add("animated");
      setTimeout(() => {
        document.getElementById(id).classList.remove("animated");
      }, 300);
    }
    image.style.left = `${
      (container.clientWidth / 100) *
      parseInt(polygonData.initialValues.left, 10)
    }px`;
    image.style.top = `${
      (container.clientWidth / 100) *
      parseInt(polygonData.initialValues.top, 10)
    }px`;

    /*      let currLeft = parseInt(image.style.left || 0, 10);
    let currTop = parseInt(image.style.top || 0, 10);

    if (diffX < 0) {
      image.style.left = currLeft - Math.abs(diffX) + "px";
    }
    if (diffX > 0) {
      image.style.left = currLeft + Math.abs(diffX) + "px";
    }

    if (diffY < 0) {
      image.style.top = currTop - Math.abs(diffY) + "px";
    }

    if (diffY > 0) {
      image.style.top = currTop + Math.abs(diffY) + "px";
    } */
  }
  image.style.transform = "";
  image = null;
  return;
}

function move(e) {
  const ev = e.touches ? e.touches[0] : e;
  if (!mousedown || !image) return;
  diffX = ev.clientX - initialX;
  diffY = ev.clientY - initialY;
  image.style.transform = `translate(${diffX}px, ${diffY}px)`;
  if (window.scene.getSoundByName("matrixPosterPaperMovement").isPlaying)
    return;
}

window.addEventListener("mouseup", stop, false);
window.addEventListener("touchend", stop, false);

const mouseDownHandler = (e) => {
  mousedown = true;
  e.preventDefault(); // STRANGE: this is needed in order to mouseup fire

  const ev = e.touches ? e.touches[0] : e;
  initialX = ev.clientX;
  initialY = ev.clientY;
  // const siblingsUnderMouse = findSiblingsUnderMouse(e)
  const siblingsUnderMouse = document.querySelectorAll(".poster-piece");
  for (let index = 0; index < siblingsUnderMouse.length; index++) {
    if (image) break;
    const element = siblingsUnderMouse[index];
    var clickOnVisiblePixel = isOnVisiblePixel(e, element);
    console.log(clickOnVisiblePixel);
    if (clickOnVisiblePixel && !image) {
      if (correctPieces.indexOf(element.id) < 0) {
        image = element;
        image.style.zIndex = 100;
        document.addEventListener("mousemove", move, false);
        document.addEventListener("touchmove", move, false);
      }
    }
    if (clickOnVisiblePixel) break;
  }
};

const urls = Object.keys(pieceImages).map((e) => pieceImages[e]);
const FlatPuzzle = function (callback, sounds) {
  posterPuzzleSounds = sounds;

  puzzleOpened = true;
  const containerHTML = html`
    <div class="poster-container" id="poster"></div>
  `;

  const puzzleWindow = CreateWindow({
    exitCallback: () => {
      correctPieces = [];
      callback();
    },
  }).element;

  render(containerHTML, puzzleWindow);

  const container = containerSelector();

  const markup = html`
    <img src=${posterBg} class="poster-bg" />
    <div>
      ${polygons.map(
        (e) =>
          html`<img
            @mousedown=${mouseDownHandler}
            @touchstart=${mouseDownHandler}
            src=${e.img}
            id=${e.name}
            crossorigin=""
            crossorigin="anonymous"
            class="poster-piece"
            style="left: ${(container.clientWidth / 100) *
            parseInt(
              e.initialValues.left,
              10
            )}px; top: ${(container.clientWidth / 100) *
            parseInt(e.initialValues.top)}px "
          />`
      )}
    </div>
  `;
  tips.matrixPoster.clear();
  render(markup, container);
  updateMatrixPosterScale();
  exitButtonPosition();
};

export default FlatPuzzle;
